import { useMutation } from '@tanstack/react-query';

import { LeLiveExportFormat, downloadLeLiveRegistrationsReport } from '~/services/OccasionsService';

export function useDownloadLeLiveRegistrations() {
  return useMutation({
    mutationFn: (format: LeLiveExportFormat) => downloadLeLiveRegistrationsReport(format),
    onSuccess: (blob, format) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `le-live-registrations.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  });
}
